import * as Mutations from './mutations';

export const PopupModule = {
    state: {
        activityPopupInfo: null,
        isActivityPopupOpen: false,
    },

    mutations: {
        [Mutations.SET_ACTIVITY_POPUP](state, isActivityPopupOpen) {
            state.isActivityPopupOpen = isActivityPopupOpen;
        },

        [Mutations.TOGGLE_ACTIVITY_POPUP](state) {
            state.isActivityPopupOpen = !state.isActivityPopupOpen;
        },

        [Mutations.UPDATE_ACTIVITY_POPUP_INFO](state, info) {
            state.activityPopupInfo = info;
        }
    },

    actions: {
        setActivityPopup(context, payload) {
            context.commit(Mutations.SET_ACTIVITY_POPUP, payload);
        },

        toggleActivityPopup(context) {
            context.getters.isActivityPopupOpen &&  context.commit(Mutations.SET_ACTIVITY_POPUP, false);
            context.commit(Mutations.TOGGLE_ACTIVITY_POPUP);
        },

        resetActivityPopup(context) {
            context.commit(Mutations.SET_ACTIVITY_POPUP, false);
            context.commit(Mutations.UPDATE_ACTIVITY_POPUP_INFO, null);
        }
    },

    getters: {
        isActivityPopupOpen: state => state.isActivityPopupOpen,

        activityPopupInfo: state => state.activityPopupInfo.data,

        activityPopupPosition: state => state.activityPopupInfo.position
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/popup/popup.module.js